<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        結果
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">結果</a>
          </li>
      </ul>
    </div>
    <!-- detail search start -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col md="6">
          <b-form-group>
            <label for="opt_date"> 検査日
              <b-button size="sm" variant="info" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
              <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1日</b-button>
              <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1週</b-button>
              <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1月</b-button>
              <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at')">週</b-button>
              <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at')">月</b-button>
            </label>
            <b-form inline>
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <!-- <b-col md="6">
          <b-form-group>
            <label for="opt_visit"> 完了日
              <b-button size="sm" variant="info" @click="set_sd('', 'finished_at')"><i class="fa fa-remove"></i></b-button>
              <b-button size="sm" variant="primary" @click="set_sd('-1d', 'finished_at')">-1日</b-button>
              <b-button size="sm" variant="primary" @click="set_sd('-1w', 'finished_at')">-1週</b-button>
              <b-button size="sm" variant="primary" @click="set_sd('-1m', 'finished_at')">-1月</b-button>
              <b-button size="sm" variant="primary" @click="set_sd('w', 'finished_at')">週</b-button>
              <b-button size="sm" variant="primary" @click="set_sd('m', 'finished_at')">月</b-button>
            </label>
            <b-form inline>
              <date-picker @change="refresh" v-model="so.opt.finished_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.finished_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col> -->
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group>
            <label for="opt_site_name">サイト名</label>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_site_name" v-model="so.opt['name']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label for="opt_site_fqdn">サイトFQDN</label>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_site_fqdn" v-model="so.opt['fqdn']"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="2">
          <b-form-group>
            <label for="opt_error">エラー</label><br>
            <c-switch v-model="so.opt['error_count']" @change="refresh"  color="warning" label variant="pill" />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group>
            <label for="opt_error">検出</label><br>
            <c-switch v-model="so.opt['detect_count']" @change="refresh"  color="danger" label variant="pill" />
          </b-form-group>
        </b-col>
        <b-col md="2">
        </b-col>
        <b-col md="6">
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <label for="ph_search_opt_type">一致タイプ</label>
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
              <b-form-radio value="and">[AND]:すべて一致</b-form-radio>
              <b-form-radio value="or">[OR]:最低でも1つは一致</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group class="float-right">
        <b-button class="btn-add" size="sm" variant="success" @click="refresh"> 検索 </b-button>
        <b-button size="sm" variant="warning" @click="reset"> リセット </b-button>
        <b-button size="sm" variant="secondary" @click="search_opt"> 閉じる </b-button>
      </b-form-group>
    </b-card>
    <!-- detail search end -->
    <b-card>
      <span class="title" v-if="show_title === true">
        最近の結果
      </span>
      <hr v-if="show_title === true">

      <b-row v-if="view_only != true">
        <!-- 기본 FQDN 으로만 검색할 것임 -->
        <b-col md="12">
          <autocomplete :autoSelect="true" @update="update" :get-result-value="getResultValue" :disabled="so.adv" :search="typing" placeholder="FQDN を入力して Enter キーを押します" @submit="onSubmit" aria-label="Typing, FQDN you are looking for"></autocomplete>
          <b-btn class="mt-2" block variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
        </b-col>
      </b-row>
      <hr v-if="view_only != true">
      <b-row>
        <b-col md="6">
          <!-- refresh -->
          <span class="text-center" v-b-tooltip.hover title="表示回数を設定できる">
            Show Count
            <select v-model="so.perPage" @change="refresh">
              <option disabled value="10">デフォルト 10</option>
              <!-- <option value=10>10</option> -->
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </span>
        </b-col>
        <b-col style="z-index:0;" v-if="view_only != true">
          <b-pagination class="pull-right" size="sm" :total-rows="getRowCount" :per-page="so.perPage" v-model="currentPage" prev-text="<" next-text=">" />
        </b-col>
        <b-col md="6" v-else class="text-right">
          <b-button size="sm" variant="primary" to="/wmds/result">結果ページへ</b-button>
        </b-col>
      </b-row>
      <hr>
      <!-- 사이트 점검 정보 -->
      <vcl-facebook v-if="loading" ></vcl-facebook>
      <b-row v-if="model && model.length">
        <item v-show="!loading" v-for="(item, index) in model" :key="index" :item="item" :index="index" @click="select"></item>
      </b-row>
      <b-row v-if="!(model && model.length) && !loading" class="text-center">
        <b-col>登録サイトの検査結果はありません</b-col>
      </b-row>
    </b-card>
    <!-- <hr>
    <router-view @refresh="refresh()"></router-view> -->
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
